import { UserProfile } from '@/services/users';

export const ROLE_COLOR_SCHEME_MAPPING: Record<
  UserProfile,
  | 'error'
  | 'success'
  | 'gray'
  | 'blue'
  | 'green'
  | 'warning'
  | 'yellow'
  | 'purple'
  | 'sky'
  | 'lightGreen'
> = {
  Administrador: 'purple',
  Assessor: 'warning',
  Subscritor: 'blue',
  'CX Atendimento': 'lightGreen',
  'Gerente Comercial': 'yellow',
  'Executivo de Vendas': 'success',
  'Assistente Comercial': 'gray',
  Corretor: 'green',
  Master: 'sky',
};

/**
 * Cores por papel do usuário de ASSESSORIA.
 *
 * `AdvisoryUser.role` usa slugs (`admin`, `assessoria`, …), não os rótulos de
 * {@link UserProfile} — indexar o mapa acima com esses valores sempre devolvia
 * `undefined` e a tag saía sem cor. As cores seguem as dos papéis equivalentes.
 */
export const ADVISORY_ROLE_COLOR_SCHEME_MAPPING: Record<
  'admin' | 'assessoria' | 'membro' | 'gerente',
  'blue' | 'green' | 'purple' | 'yellow' | 'warning' | 'gray'
> = {
  admin: 'purple',
  assessoria: 'warning',
  gerente: 'yellow',
  membro: 'gray',
};
